import axios from 'axios'
import {apiDomain} from '../../config'

let axiosConfigRequest = {
  headers: {
    'Content-Type': 'application/json',
    'token': localStorage.getItem('access_token')
  }
}

export default {
  getAll () {
    return new Promise((resolve, reject) => {
      axios.get(apiDomain + '/agreements/', { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token'),
        'user_id': localStorage.getItem('user_id')
      }})
        .then((response) => {
          if (response.data.status === 'success') {
            var data = [response.data.status, response.data.agreements, response.data.insert_data || [], response.data.role, response.data.energy_company_id]
            resolve(data)
          } else {
            var data = [response.data.status, response.data.message]
            resolve(data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getBy (agreementId) {
    return new Promise((resolve, reject) => {
      axios.get(apiDomain + '/agreement/' + agreementId + '/', { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          if (response.data.status === 'success') {
            var data = [response.data.status, response.data.agreement, response.data.update_data, response.data.role, response.data.energy_company_id]
            resolve(data)
          } else {
            var data = [response.data.status, response.data.message]
            resolve(data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  save (dataAgreement) {
    return new Promise((resolve, reject) => {
      axios.post(apiDomain + '/agreements/create/', dataAgreement, { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          var data = [response.data.status, response.data.message]
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  update (id, dataAgreement) {
    return new Promise((resolve, reject) => {
      axios.put(apiDomain + '/agreement/update/' + id + '/', dataAgreement, { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          var data = [response.data.status, response.data.message]
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  delete (id, hauls) {
    return new Promise((resolve, reject) => {
      axios.put(apiDomain + '/agreement/delete/' + id + '/', hauls , { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          var data = [response.data.status, response.data.message]
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  restore (id) {
    return new Promise((resolve, reject) => {
      axios.delete(apiDomain + '/agreement/restore/' + id + '/', { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          var data = [response.data.status, response.data.message]
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  verify (dataAgreement) {
    return new Promise((resolve, reject) => {
      axios.post(apiDomain + '/agreements/verify/', dataAgreement, { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          var data = [response.data.status, response.data.message, response.data.data]
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAllPending () {
    return new Promise((resolve, reject) => {
      axios.get(apiDomain + '/hauls_pending/', { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token'),
        'user_id': localStorage.getItem('user_id')
      }})
        .then((response) => {
          if (response.data.status === 'success') {
            var data = response.data
       //     var data = [response.data.status, response.data.hauls_pending, response.data.role, response.data.energy_company_id]
            resolve(data)
          } else {
         //   var data = [response.data.status, response.data.message]
            var data = response.data
            resolve(data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  filters_agree (filters) {
    return new Promise((resolve, reject) => {
      axios.put(apiDomain + '/user/filters_agree/', filters, { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token')
      }})
        .then((response) => {
          var data = [response.data.status, response.data.message]
          resolve(data)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getPendingDetail (PendingId) {
    return new Promise((resolve, reject) => {
      axios.get(apiDomain + '/hauls_pending_detail/'+ PendingId + '/', { headers: {
        'Content-Type': 'application/json',
        'token': localStorage.getItem('access_token'),
        'user_id': localStorage.getItem('user_id')
      }})
        .then((response) => {
          if (response.data.status === 'success') {
            var data = response.data
            resolve(data)
          } else {
            var data = response.data
            resolve(data)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

}



// WEBPACK FOOTER //
// ./src/views/agreements/agreements_service.js